import { render, staticRenderFns } from "./ModalCustomerList.vue?vue&type=template&id=c922fa12&scoped=true"
import script from "./ModalCustomerList.vue?vue&type=script&lang=js"
export * from "./ModalCustomerList.vue?vue&type=script&lang=js"
import style0 from "./ModalCustomerList.vue?vue&type=style&index=0&id=c922fa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922fa12",
  null
  
)

export default component.exports